export default function convertibleFromObject(obj: Record<string, string>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key.toLowerCase(), encodeURIComponent(value)]),
  );
}
